import { Badge } from "react-bootstrap";
import { StringUtil } from "./string.util";
import { CampaignStateDisplayName } from "../models/campaign.model";

export const StatusColor = (status) => {
  const tag = "pd-5 rounded-10 tag-";
  return {
      ACTIVE: tag + "green", // Running
      INACTIVE: tag + "gray", // Canceled
      SCHEDULED: tag + "azure", // Scheduled
      DRAFT: tag + "warning", // Draft
      PAUSED: tag + "gray", // Idle
      FINISHED: tag + "warning",
      CANCELED: tag + "gray-dark"
  }[status]
}

export const BadgeState = (state, text) => {
  const stateDisplayName = CampaignStateDisplayName(state)
  const stateLowerCase = StringUtil.formatStringFirstLetter(stateDisplayName)
  return <Badge className={StatusColor(state)} bg="me-5">{stateLowerCase} {text}</Badge>;
};